import axios from 'axios';
import authHeader from './auth-header';

const API_URL = 'https://dacmethodbackend.herokuapp.com/api/test/';

class Woweek {
    registerweek(usercode, useryear, userweek, weekday1, weekday2, weekday3, weekday4, weekday5, weekday6, weekday7){
        return axios.post(API_URL+'insertweek',{usercode, useryear, userweek, weekday1, weekday2, weekday3, weekday4, weekday5, weekday6, weekday7});
    }

    getweek(){
        return axios.get(API_URL + 'findweek', { headers: authHeader() });
    }


}
export default new Woweek();
